"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _environment = require("@sm/utils/dist/environment");
var _ = require("..");
// fix for downstream tree-shaking

var ComponentMetricsProvider = function ComponentMetricsProvider(_ref) {
  var name = _ref.name,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? null : _ref$attributes,
    _ref$disableDA = _ref.disableDA,
    disableDA = _ref$disableDA === void 0 ? false : _ref$disableDA,
    actionFlow = _ref.actionFlow,
    actionType = _ref.actionType,
    children = _ref.children;
  var envDetails = (0, _environment.getClientEnvironmentDetails)();
  if (envDetails.isBrowser) {
    _.MetricsTracker.track({
      name: _.USER_EVENTS.COMPONENT_ADD,
      data: {
        componentName: name,
        attributes: attributes,
        disableDA: disableDA,
        actionType: actionType,
        actionFlow: actionFlow
      }
    });
  }
  return children;
};
var _default = exports.default = ComponentMetricsProvider;
module.exports = exports.default;
//# sourceMappingURL=ComponentMetricsProvider.js.map